import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "wa_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((cur) => {
      const ex = cur.find((i) => i.product_id === product.id);
      if (ex) return cur.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + qty } : i);
      return [...cur, {
        product_id: product.id, sku: product.sku, name: product.name,
        slug: product.slug, image: product.images?.[0], qty, price: product.price,
      }];
    });
  };

  const remove = (productId) => setItems((cur) => cur.filter((i) => i.product_id !== productId));
  // Guard against NaN (comes from parseInt("") on empty inputs) so the
  // cart never gets stuck with an unrenderable NaN qty and a broken total.
  const setQty = (productId, qty) => {
    const safe = Number.isFinite(qty) ? Math.max(1, Math.floor(qty)) : 1;
    setItems((cur) => cur.map((i) => i.product_id === productId ? { ...i, qty: safe } : i));
  };
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, subtotal }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
